import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { GET_GL_MASTER_DATA } from "./apiRoutes";

interface MutateProps {
  data: FieldValues;
  communityId: string;
  attachmentId: string;
}

const mutateCommitBulkUploadGlMaster = async ({
  data,
  communityId,
  attachmentId,
}: MutateProps) => {
  return await axiosAuth.post(
    `${GET_GL_MASTER_DATA}/community/${communityId}/bulk/${attachmentId}/commit`,
    data
  );
};

const useCommitBulkUploadGlMasterMutation = (
  queryParams?: UseMutationOptions<any, Error, MutateProps, unknown>
) =>
  useMutation({
    mutationFn: mutateCommitBulkUploadGlMaster,
    ...queryParams,
  });

export default useCommitBulkUploadGlMasterMutation;
